import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useStoreSelector } from '@ublique/platform'
import { useTranslation } from 'react-i18next'
import { first, isEmpty } from 'lodash'
import useFilters from '../hooks/useFilters'
import { storeCollaborationStore } from '../state'
import { updateState } from 'utils/state'
import { NS } from '../constants'
import Row from '@ublique/components/Template/components/Row'
import Column from '@ublique/components/Template/components/Column'
import Dropdown from '@ublique/components/Dropdown'
import Multiselect from './MultiSelect'
import '../index.scss'

function Filters({ title, roomsFilter = false }) {
  const { view } = useParams()
  const { t } = useTranslation('ExtraOutput')
  const tExtra = (n) => t(`${NS}.${n}`)

  const filters = useStoreSelector(
    'storeCollaboration',
    (state) => state.filters
  )

  const roomsList = filters.allRooms

  const { storesList, loading /* , isStoreRole  */ } = useFilters(
    filters.store?.id
  )

  const onChange = (val, key) => {
    const updatedFilters = { ...filters, [key]: val }

    const newFilters = resetAllDepsFiltersByKey(updatedFilters, key)

    updateState(storeCollaborationStore, {
      filters: newFilters
    })
  }

  const resetAllDepsFiltersByKey = (filters, key) => {
    // Resetting dependent filters (rooms depend on store)
    if (key === 'store') {
      const depsFilters = ['selectedRooms']
      depsFilters.forEach((depKey) => {
        filters[depKey] = []
      })
    }

    return filters
  }

  useEffect(() => {
    // Selecting first store by default
    if (!isEmpty(storesList) && isEmpty(filters.store)) {
      onChange(first(storesList), 'store')
    }
  }, [storesList])

  return (
    <Row className='store-collaboration-filters-row'>
      <Column lg={roomsFilter ? 6 : 9}>
        <h2>{title}</h2>
      </Column>
      {roomsFilter && (
        <Column lg={3}>
          <Multiselect
            key={filters.store?.id + roomsList.length}
            itemToString={(item) => (item && item.text ? item.text : '')}
            onChange={({ selectedItems }) =>
              onChange(selectedItems, 'selectedRooms')
            }
            id='rooms'
            title={tExtra('ROOMS')}
            items={roomsList}
            placeholder={loading && tExtra('LOADING_DATA')}
            disabled={isEmpty(filters.store) || loading}
            selected={
              isEmpty(filters.selectedRooms) ? roomsList : filters.selectedRooms
            }
          />
        </Column>
      )}
      <Column lg={3}>
        <Dropdown
          key={`has-stores-${!!storesList.length}-${view}-${JSON.stringify(
            filters.store
          )}`}
          ///disabled={size(storesList) === 1}
          items={storesList}
          label={t('Common:Select')}
          titleText={tExtra('STORES')}
          onChange={({ selectedItem }) => onChange(selectedItem, 'store')}
          id='stores-list'
          ariaLabel='Stores'
          itemToString={(item) => (item ? item?.title : '')}
          initialSelectedItem={
            !isEmpty(filters.store) ? filters.store : undefined
          }
        />
      </Column>
    </Row>
  )
}

export default Filters
